import { datadogLogs } from '@datadog/browser-logs';

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem('accessToken', accessToken);
};

export const setRoleType = (roleType: string) => {
  // Don't store undefined or null values
  if (roleType && roleType !== 'undefined' && roleType !== 'null') {
    localStorage.setItem('roleType', roleType);
  }
};

export const setRoleTypeOptions = (roleTypes: string[]) => {
  localStorage.setItem('roleTypeOptions', JSON.stringify(roleTypes));
};

export const setClients = (clients: any) => {
  localStorage.setItem('clients', JSON.stringify(clients));
};

export const setSelectedClient = (client: any) => {
  localStorage.setItem('selectedClient', JSON.stringify(client));
};

export const setRecipients = (recipients: any) => {
  localStorage.setItem('recipients', JSON.stringify(recipients));
};

export const setSelectedRecipient = (recipient: any) => {
  localStorage.setItem('selectedRecipient', JSON.stringify(recipient));
};

export const setUserName = (name: string) => {
  localStorage.setItem('userName', name);
};

export const getAccessToken = () => localStorage.getItem('accessToken');

export const getRoleType = () => {
  const roleType = localStorage.getItem('roleType');
  // Handle the case where 'undefined' string is stored instead of null
  return roleType === 'undefined' || roleType === null ? null : roleType;
};

export const getRoleTypeOptions = () => JSON.parse(localStorage.getItem('roleTypeOptions') || '[]');

export const getClients = () => JSON.parse(localStorage.getItem('clients') || '[]');

export const getSelectedClient = () => {
  const stored = localStorage.getItem('selectedClient');
  if (!stored) return null;
  const parsed = JSON.parse(stored);
  if (parsed?.id == null) return null;
  // Number('') and whitespace coerce to 0, which is the super-admin "ALL" sentinel; reject them.
  if (typeof parsed.id === 'string' && parsed.id.trim() === '') return null;
  const id = Number(parsed.id);
  return Number.isFinite(id) ? { ...parsed, id } : null;
};

export const getRecipients = () => {
  const stored = localStorage.getItem('recipients');
  return stored ? JSON.parse(stored) : null;
};

export const getSelectedRecipient = () => {
  const stored = localStorage.getItem('selectedRecipient');
  return stored ? JSON.parse(stored) : null;
};

export const getUserName = () => localStorage.getItem('userName');

const clearRBACItems = () => {
  localStorage.removeItem('activeRole');
  localStorage.removeItem('roleType');
  localStorage.removeItem('roleTypeOptions');
  localStorage.removeItem('clients');
  localStorage.removeItem('selectedClient');
  localStorage.removeItem('recipients');
  localStorage.removeItem('selectedRecipient');
  localStorage.removeItem('accessToken');
};

export const clearLocalStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userName');
  clearRBACItems();
  localStorage.removeItem('adminRefreshedv2');
  localStorage.removeItem('adminRefreshed');
};

export const resetAdminRefresh = () => {
  localStorage.removeItem('adminRefreshedv2');
};

export const clearRolesandResources = () => {
  if (localStorage.getItem('adminRefreshedv2') !== 'true') {
    datadogLogs.logger.debug('Clearing RBAC Local Storage');
    clearRBACItems();
    localStorage.setItem('adminRefreshedv2', 'true');
  }
};
